import { render, staticRenderFns } from "./VueAvatarEditor.vue?vue&type=template&id=10ba89d7"
import script from "./VueAvatarEditor.vue?vue&type=script&lang=js"
export * from "./VueAvatarEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ba89d7')) {
      api.createRecord('10ba89d7', component.options)
    } else {
      api.reload('10ba89d7', component.options)
    }
    module.hot.accept("./VueAvatarEditor.vue?vue&type=template&id=10ba89d7", function () {
      api.rerender('10ba89d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-avatar-editor-improved/src/components/VueAvatarEditor.vue"
export default component.exports